(() => {
 if(window.sharpFavoritesPolish) return;
 window.sharpFavoritesPolish = true;
 document.addEventListener('click', event => {
  const choose=event.target.closest('.shr-favorites .shr-product-shop');
  if(!choose || choose.closest('dialog')) return;
  const card=choose.closest('[data-shr-product]');
  const options=card.querySelector('[data-favorite-custom-options]');
  if(!options) return;
  event.preventDefault();
  const dialog=document.createElement('dialog');
  dialog.className='shr-favorite-dialog';
  const title=document.createElement('h2');
  title.id='FavoriteChoice-'+Math.random().toString(36).slice(2);
  title.textContent=card.querySelector('h3').textContent.trim();
  dialog.setAttribute('aria-labelledby',title.id);
  const close=document.createElement('button');
  close.type='button';close.className='shr-favorite-dialog-close';
  close.setAttribute('aria-label','Close options');close.textContent='×';
  const body=document.createElement('div');body.className='shr-favorite-dialog-body';
  const preview=document.createElement('figure');preview.className='shr-favorite-preview';
  const frame=document.createElement('div');frame.className='shr-favorite-preview-frame';
  const image=document.createElement('img');image.width=640;image.height=640;image.decoding='async';image.sizes='(min-width:750px) 320px, 45vw';
  frame.append(image);
  const caption=document.createElement('figcaption');caption.setAttribute('aria-live','polite');caption.setAttribute('aria-atomic','true');
  const status=document.createElement('span');status.className='visually-hidden';status.setAttribute('role','status');
  preview.append(frame,caption,status);
  const marker=document.createComment('Team options return here');options.before(marker);
  const continuation=choose.cloneNode(true);continuation.textContent='Continue to options →';
  const footer=document.createElement('div');footer.className='shr-favorite-dialog-footer';footer.append(continuation);
  body.append(preview,options);dialog.append(close,title,body,footer);card.append(dialog);options.hidden=false;
  let sequence=0,alive=true;
  const events=new AbortController();
  const buttons=[...options.querySelectorAll('[data-shr-team-choice]')];
  const primary=card.querySelector('.shr-product-primary');
  image.src=primary?.currentSrc||primary?.src||'';
  image.alt=title.textContent;
  function select(button) {
   const token=++sequence;
   const name=button.getAttribute('aria-label')||button.textContent.trim();
   buttons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
   caption.textContent=name;
   continuation.href=button.dataset.url;
   continuation.setAttribute('aria-disabled','true');
   continuation.tabIndex=-1;
   preview.setAttribute('aria-busy','true');status.textContent='Loading '+name+' preview';
   const next=new Image();
   next.src=button.dataset.image;
   next.decode().then(()=>{
    if(!alive||token!==sequence)return;
    image.src=next.src;image.alt=title.textContent+' — '+name;
    preview.removeAttribute('aria-busy');status.textContent='';
    continuation.removeAttribute('aria-disabled');continuation.removeAttribute('tabindex');
   }).catch(()=>{
    if(!alive||token!==sequence)return;
    image.removeAttribute('src');image.alt='Preview unavailable for '+name;
    preview.removeAttribute('aria-busy');status.textContent='Preview unavailable. Product options remain available.';
    continuation.removeAttribute('aria-disabled');continuation.removeAttribute('tabindex');
   });
  }
  options.addEventListener('click',e=>{const button=e.target.closest('[data-shr-team-choice]');if(button)select(button);},{capture:true,signal:events.signal});
  continuation.addEventListener('click',e=>{if(continuation.getAttribute('aria-disabled')==='true')e.preventDefault();});
  close.addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
  const prior=document.body.style.overflow;document.body.style.overflow='hidden';
  dialog.addEventListener('close',()=>{alive=false;++sequence;events.abort();options.hidden=true;marker.replaceWith(options);dialog.remove();document.body.style.overflow=prior;choose.focus({preventScroll:true});},{once:true});
  const selected=buttons.find(button=>new URL(button.dataset.url,document.baseURI).href===choose.href)||buttons.find(button=>button.getAttribute('aria-pressed')==='true')||buttons[0];
  dialog.showModal();if(selected)select(selected);close.focus({preventScroll:true});
 });
})();
